export default __webpack_public_path__ + "static/media/logo512.58bf7b1a.png";